import { buildModelManager } from "../builder.js";
const DefaultShopifyDiscountCustomerGetsCollectionSelection = {
  __typename: true,
  id: true,
  collectionId: true,
  createdAt: true,
  discountId: true,
  shopId: true,
  updatedAt: true
};
const modelApiIdentifier = "shopifyDiscountCustomerGetsCollection";
const pluralModelApiIdentifier = "shopifyDiscountCustomerGetsCollections";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyDiscountCustomerGetsCollectionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyDiscountCustomerGetsCollectionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountCustomerGetsCollectionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountCustomerGetsCollectionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountCustomerGetsCollectionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountCustomerGetsCollectionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountCustomerGetsCollectionSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyDiscountCustomerGetsCollection does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyDiscountCustomerGetsCollectionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyDiscountCustomerGetsCollectionSelection,
  operations
);
export {
  DefaultShopifyDiscountCustomerGetsCollectionSelection,
  ShopifyDiscountCustomerGetsCollectionManager
};
//# sourceMappingURL=ShopifyDiscountCustomerGetsCollection.js.map
